import apiFetch from '../apiFetch'

export default function (idInstalacion, token) {
  return apiFetch({endPoint: `Instalacion/getInstalacionCambioEstado`, method: 'POST', body: {idInstalacion}, token: token})
}
